const bankRiskRouter = {
  path: '/bankRisk',
  component: () => import(/* webpackChunkName: "bankRisk" */ '@/pages/bankRisk/layout'),
  meta: { title: '银行卡风险' },
  children: [
    {
      path: 'index',
      name: 'queryIndex',
      meta: { title: '查询' },
      component: () => import(/* webpackChunkName: "bankRisk" */ '@/pages/bankRisk/index'),
    },
    {
      path: 'history',
      name: 'queryHistory',
      meta: { title: '查询' },
      component: () => import(/* webpackChunkName: "bankRisk" */ '@/pages/bankRisk/history'),
    },
  ],
}

export default bankRiskRouter
